import { UserService } from '@fnv-core/authentication';
import { IField } from './reactcomponents/interfaces/Fields';
import { IFormConfig } from './reactcomponents/interfaces/FormConfig';

interface IFormWindow extends Window {
  formConfig: IFormConfig;
  formDefinitions: IField[];
}

declare var window: IFormWindow;
declare var formConfig: any;
declare var formDefinitions: any;

export function initReactController() {
  let logoutTimer;

  const logoutTimeoutHandler = () => {
    logoutTimer = undefined;
    UserService.removeCookiesOnLogout();
    location.href = "/logout?state=" + location.href;      
  };

  if ($(".react-form-widget").length > 0) {
    $(".react-form-widget").each((index, reactElement) => {
      const reactApp = $(reactElement).attr("data-react");

      if (reactApp === "FNVFormV2Controller") {
        import('./reactcomponents/controllers/FormV2Controller').then(function(react) {
          react.initReact(window.formDefinitions ?? {} as any,
            $(reactElement).attr('data-formid'), 
            $(reactElement).attr('data-reactid'));
        });
      } else {
        // Generic React form component
        import('./reactcomponents/controllers/FNVKenticoAppController').then(function(react) {
          let reactGuid = $(reactElement).attr("data-reactid");
          let formConfigGuid = $(reactElement).attr("data-form-config");
          let rootid = $(reactElement).attr("id");

          react.initReact(
            window[formConfigGuid] !== undefined ? window[formConfigGuid] : {},
            window['formDefinitions' + reactGuid] !== undefined ? window['formDefinitions' + reactGuid] : [],
            rootid
          );
        });
      }
    });
  } else if ($("#root").length > 0) { 
    const reactApp = $("#root").attr("data-react");
    if (reactApp === "MijnFNVFormController") {
      import('./reactcomponents/controllers/MijnFNVAppController').then(function(react) {      
          react.initReact({}, {form: []});
      });    
    } else if (reactApp === "FNVKenticoFormController") {
      import('./reactcomponents/controllers/FNVKenticoAppController').then(function(react) {  
        react.initReact(typeof formConfig !== "undefined" ? formConfig : {}, 
          typeof formDefinitions !== "undefined" ? formDefinitions : []
        );
      });    
    } else if (reactApp === "FNVFormController") {

      // FNV React-form
      import('./reactcomponents/controllers/FNVAppController').then(function(react) {

        if (window.formConfig.initialState !== undefined ) {
          $.ajax({ url: window.formConfig.initialState }).done((data) => {
            window.formConfig.initialState = data;

            react.initReact(window.formConfig, window.formDefinitions);
          });
        }  else {
          react.initReact(window.formConfig, window.formDefinitions);
        }
      });
    } else if (reactApp === "FNVFormV2Controller") {
      import('./reactcomponents/controllers/FormV2Controller').then(function(react) {
        const rootElement = document.querySelector('#root');
        react.initReact(window.formDefinitions ?? {} as any,
          rootElement.getAttribute('data-formid'), 
          rootElement.getAttribute('data-reactid'));
      });
    } else {
      // Generic React component
      import('./reactcomponents/controllers/GenericAppController').then(function(react) {
        react.initReact(reactApp);
      });
    }
  } else if (document.querySelectorAll('[data-react-app]').length > 0) {
    const appElements = document.querySelectorAll('[data-react-app]');
    appElements.forEach(element => {
      let reactAppController;
      switch (element.getAttribute('data-react-app')) {
        case 'Modal':
          reactAppController = import('./reactcomponents/controllers/ModalAppController');
          break;
        default:
          reactAppController = import('./reactcomponents/controllers/GenericAppController');
      }

      reactAppController.then((react) => {
        react.initReact(element);
      });
    });
  } else if ($(".react-feature-container").length > 0) {
    $(".react-feature-container").each((index, reactElement) => {
      import('./reactcomponents/controllers/FeatureController').then(function(react) {
        react.initReact(
          $(reactElement).attr("data-feature-name"), 
          $(reactElement).attr("id"), 
          window[$(reactElement).attr("data-feature-definition")]);
      });
    });
  } else {
    // Only trigger logout timer if user is logged-in 
    if (UserService.isAuthenticated()) {
      const logoutDuration = parseInt($(".mijn-fnv__user-menu-item-loggedin").attr("data-login-duration")) || 4;

      if (logoutDuration > 0) {          
        logoutTimer = setTimeout(logoutTimeoutHandler, 1000 * 60 * 60 * logoutDuration);
      }
    }
  }
}
